import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  spacing
} from '../../../theme';
import { StyledAvatar } from '../../shared/Avatar.styled';
import { Heading4 } from '../../shared/Typography';

export const StyledOfferFooter = styled.aside`
  margin-bottom: ${spacing('xl')};
`;

export const StyledOfferFooterContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  padding: ${spacing('xl')} ${spacing('md')};
  border-top: 1px solid ${color('midnight_700')};
  border-bottom: 1px solid ${color('midnight_700')};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const StyledOfferFooterLogo = styled.div`
  img{ 
    display: block;
    max-height: 8rem;
    max-width: 15rem;
    margin-bottom: ${spacing('lg')};
  }
`;

export const StyledOfferFooterTitle = styled(Heading4)`
  margin-bottom: ${spacing('lg')};
`;

export const StyledOfferFooterActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: ${spacing('lg')};
  > * {
    margin-left: ${spacing('xs')};
    margin-right: ${spacing('xs')};
  }
`;

export const StyledOfferFooterText = styled.p`
  font-weight: ${fontWeight('medium')};
  line-height: 1.25;
  color: ${color('text_subtle_inverse')};
  max-width: ${container('lg')};
  margin-top: 0;
  margin-bottom: ${spacing('lg')};

  strong {
    font-weight: ${fontWeight('extraBold')};
  }
`;

export const StyledOfferFooterScoutTitle = styled.h5`
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('black')};
  text-transform: uppercase;
  line-height: 1.33;
  margin-top: 0;
  margin-bottom: ${spacing('xs')};
`;

export const StyledOfferFooterScout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;

  ${StyledAvatar} {
    margin-right: ${spacing('xs')};
  }
`;

export const StyledOfferFooterScoutLabel = styled.span`
  display: block;
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('bold')};
  text-transform: uppercase;
  line-height: 1.33;
  color: ${color('text_subtle_inverse')};
`;

export const StyledOfferFooterScoutName = styled.a`
  display: block;
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('bold')};
  line-height: 1.14;
  color: ${color('link_inverse')};
  margin-bottom: ${spacing('xs2')};
`;
